import { Tag } from "primereact/tag";
const index = ({ severity, value }) => {
  return <Tag severity={severity} value={value}></Tag>;
};

export default index;
